






























































import SimpleMap from '../../core/components/SimpleMap.vue';
import Input from '../../core/components/Input.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIdsFromList,
    getMaxValueFromArray,
    getIndexFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    MultipleSelect,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        SimpleMap,
        Input,
        Combobox,
        MultipleSelect,
        Button,
    }
})
export default class ModalSetVehicleCalibrationFactor extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: -1}) vehicleID: number;
    @Prop({default(){return []}}) itemsSettings: Array<object>;
    errorMsg: string = "";
    workWidth: number | null = null;
    loadingWorkWidth: boolean = false;
    preselectedMessage: string = 'Se pre-selecciono el ancho de trabajo mas reciente'
    warningMessage: string = '';

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submitAction() {
        this.loadingWorkWidth = true;
        let config = {
            "vehicle_id": this.vehicleID,
            "value": Number(this.workWidth)
        } 
        InsuranceServices.setVehicleWorkWidth(
            config
        ).then((res) => {
            this.$_successDeleteRecipients(res['message']);
            this.loadingWorkWidth = false;
        }).catch((error) => {
            this.loadingWorkWidth = false;
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudo guardar el ancho de trabajo'
            });
        })
    }

    updateWorkWidth(value) {
        if(value === ''){
            value = null
        }
        this.workWidth = value;
    }

    setWorkWidth(){
        this.loadingWorkWidth = true;
        let config = {
            "vehicle_id": this.vehicleID,
            "value": Number(this.workWidth)
        } 
        InsuranceServices.setVehicleWorkWidth(
            config
        ).then((res) => {
            this.$_successDeleteRecipients(res['message']);
            this.loadingWorkWidth = false;
        }).catch((error) => {
            this.loadingWorkWidth = false;
            this.showCatchLoadingDialog(error, 'No se pudo enviar el factor de calibracion')
        })
    }

    get formIsValid() {
        this.errorMsg = '';
        if(this.workWidth == null){
            this.errorMsg = 'No ingreso el valor'
            return false
        }
        return true
    }

    preselectWorkWidth(){
        if(this.itemsSettings.length > 0){
            let idsSettings = this.itemsSettings.map(function(item){
                return item['id']
            })
            let higherIndex = getMaxValueFromArray(idsSettings);
            let indexInList = getIndexFromList(this.itemsSettings, 'id', higherIndex);
            if(indexInList !== -1){
                this.updateWorkWidth(this.itemsSettings[indexInList]['work_width']);
            }
        }
    }



    @Emit()
    closeModal() {}

    mounted() {
        this.preselectWorkWidth();
    }
}
